import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { VersionCheckService } from './version-check.service';

const VERSION_ERROR_THROTTLE_MS = 5 * 60 * 1000; // 5 minutes

export const versionCheckOnErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const versionCheck = inject(VersionCheckService);

  return next(req).pipe(
    tap({
      error: () => {
        const elapsed = Date.now() - versionCheck.lastCheckedAt;
        if (elapsed > VERSION_ERROR_THROTTLE_MS) {
          versionCheck.checkNow();
        }
      },
    }),
  );
};
